import HybridWorkflow from "./hybrid";

export default HybridWorkflow;
